import { FC } from 'react'

import { type ReportOption } from '../ReportList/options'

const SelectedOptionHeader: FC<ReportOption> = ({ title, icon }) => (
  <div className="gap-xxs p-xs rounded-m flex items-center justify-center bg-gray-100 text-gray-900">
    {icon}
    <span className="text-base font-semibold">{title}</span>
  </div>
)

export default SelectedOptionHeader
